if (!customElements.get('filter-form')) {
  customElements.define(
    'filter-form',
    class FilterForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('.apply__filter')
        this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
        this.clearButton = this.querySelector('.filter__reset');
        this.clearButton.addEventListener('click', this.onResetHandler.bind(this));
        this.inputs = this.querySelectorAll('.flt__input');
        this.ranges = this.querySelectorAll('.flt__input[type="range"');
        this.slider = this.querySelector('.price-slider');
        this.slidermin = this.querySelector('.range-min');
        this.slidermax = this.querySelector('.range-max');
        this.sort = this.querySelector('.flt__input[type="radio"]');
        let that = this;
        this.inputs.forEach(function (e) {
          e.addEventListener('change', that.onChangeFilter.bind(that));
        });

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        
        evt.preventDefault();
            document.querySelector('.filters__close').click();
       /* this.handleErrorMessage();

        const formData = new FormData(this.form);
        const params = new URLSearchParams(formData);
        var url = window.location.href.split('?')[0] + '/?' + params.toString();
        document.querySelector('body').classList.add('filtering');
        nextPage = false;
        nextContentFiltered(url);*/
      }

      onResetHandler(evt) {
        evt.preventDefault();

        this.handleErrorMessage();
        this.inputs.forEach(function (e) {
          e.checked = false;
        });
        this.ranges[0].value = 0;
        let rmax = this.ranges[1].getAttribute('max');
        this.ranges[1].value = rmax;
        this.slider.style.left = 0;
        this.slider.style.right = 0;
        this.slidermin.value = 0;
        this.slidermax.value = parseInt(rmax) * 0.01;
        this.sort.checked = true;

        var url = window.location.href.split('?')[0];
        document.querySelector('body').classList.add('filtering');
        document.querySelector('.filter__reset').classList.add('clean');
        nextPage = false;
        nextContentFiltered(url);
      }

      onChangeFilter(evt) {
        evt.preventDefault();

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const params = new URLSearchParams(formData);
        var url = window.location.href.split('?')[0] + '/?' + params.toString();
        document.querySelector('body').classList.add('filtering');
        document.querySelector('.filter__reset').classList.remove('clean');
        nextPage = false;
        nextContentFiltered(url);
 
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.filter-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.filter-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

async function nextContentFiltered(url) {
  setTimeout(function () {
    window.scrollTo({ top: 0 });
  }, 200);
  try {
    // Realizar la solicitud fetch
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }

    // Obtener el texto de la respuesta
    const htmlText = await response.text();

    // Usar una expresión regular para extraer el contenido entre los comentarios <!-- ajax -->
    const ajaxContent = htmlText.match(/<!-- ajax -->([\s\S]*?)<!-- ajax -->/i);

    // Verificar si se encontró el contenido
    if (ajaxContent && ajaxContent[1]) {
      // Crear un contenedor temporal para el contenido extraído
      const tempDiv = document.createElement('div');
      tempDiv.classList.add('collection__grid');
      tempDiv.innerHTML = ajaxContent[1];


      // Agregar el contenido extraído al body
      document.querySelector('.collection__container .wrp').innerHTML = '';
      document.querySelector('.collection__container .wrp').appendChild(tempDiv);
      document.querySelectorAll('article').forEach(function (e) {
        let h = e.getBoundingClientRect().top;
        if (h < window.innerHeight) {
          e.classList.add('show');
        }
      });
        const match = htmlText.match(/<input[^>]*id=["']filtered_products["'][^>]*value=["']([^"']+)["']/i);

        if (match) {
        let filterdProducts = match[1];
        document.querySelector('.collection__count').innerHTML = '('+filterdProducts+')';
        /*if(filterdProducts == '0'){
            document.querySelector('.no--results').style.display='block';
        }else{
             document.querySelector('.no--results').style.display='none';
        }*/
        } 
        
        const params = new URLSearchParams(url);
        const appliedFilters = [];
        for (let [key, value] of params.entries()) {
        let maxp = parseFloat(document.querySelector('input[name="filter.v.price.lte"]').getAttribute('max'));
        if (key.startsWith('filter.v.')) {
            if(key == 'filter.v.price.gte' && (value == '' || value== 0)){

            }else{
                
            if(key == 'filter.v.price.lte' && value == maxp){}else{
                    appliedFilters.push({ key, value });
                }
            }
            
        }
        let filtersApl = appliedFilters.length;
        if(filtersApl == 0){
            document.querySelector('.nFilters').innerHTML='';
        }else{
            document.querySelector('.nFilters').innerHTML=' ('+filtersApl+')';
        }
        }

        console.log("Filtros aplicados:", appliedFilters);
      document.querySelector('body').classList.remove('filtering');
      nextPage = true;
    } else {
      console.error('No se encontró contenido entre los comentarios <!-- ajax -->');
    }
  } catch (error) {
    console.error('Error al realizar la solicitud fetch:', error);
  }
  ScrollTrigger.refresh();
}
